

document.addEventListener('DOMContentLoaded', () => {
  const list = document.getElementsByClassName('sliderSection');

  for (splide of list) {
    let slidesPerPage = +splide.dataset.numberOfSlides;
    if (isNaN(slidesPerPage)) {
      slidesPerPage = 1;
    }
    const splideConfigs = {
      type: 'loop',
      perPage: slidesPerPage,
      perMove: 1,
      pagination: false,
      arrows: true,
      breakpoints: {
        1024: {
          perPage: 1,
        },
        767: {
          perPage: 1,
        },
        480: {
          perPage: 1,
        },
      }
    }
    new Splide("#" + splide.id, splideConfigs).mount();
  }

  //setting slide heights to a uniform height, per slider section
  const sliderTexts = document.querySelectorAll(".slider__text");
  const sliderSectionHeights = new Map();
  sliderTexts.forEach(function (element) {
    if (!sliderSectionHeights.has(element.id)) {
      sliderSectionHeights.set(element.id, element.clientHeight);
    }
    if (element.clientHeight > sliderSectionHeights.get(element.id)) {
      sliderSectionHeights.set(element.id, element.clientHeight);
    }
  });

  sliderTexts.forEach(function (element) {
    element.style.height = sliderSectionHeights.get(element.id) + "px";
  });
});